import { render, staticRenderFns } from "./ProdutoConsumo.vue?vue&type=template&id=5ca26031&scoped=true"
import script from "./ProdutoConsumo.vue?vue&type=script&lang=js"
export * from "./ProdutoConsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca26031",
  null
  
)

export default component.exports